module.exports = __webpack_public_path__ + "files/1b3c0ada204c72f99386a99545a5ccfc.png";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/alpha-horizontal.png
// module id = 588
// module chunks = 60